export function About() {
  return (
    <section className="about section-axis" id="about" aria-labelledby="about-title">
      <div className="page-shell section-frame" data-reveal>
        <div className="section-kicker">
          <span className="eyebrow">Обо мне</span>
          <span>Маркетинг, продукт и визуальная система — в одном процессе.</span>
        </div>

        <h2 className="about-title" id="about-title">Не сложнее.<br /><em>А яснее.</em></h2>

        <div className="about-copy">
          <p className="lead">Я соединяю маркетинг, продукт и аналитику.</p>
          <p>Помогаю бизнесу пройти путь от идеи до работающего цифрового продукта. Фокус — на ясной структуре, понятной коммуникации и решениях, которые можно измерить.</p>
        </div>

        <div className="about-foot">
          <p>Сначала — понять задачу.<br />Потом — выбирать инструменты.</p>
          <span className="eyebrow">ALEXADS · персональный подход</span>
        </div>
      </div>
    </section>
  );
}
